import { DatePicker } from "antd";
import React, { useState } from "react";
import dayjs from "dayjs"; // 👈 important
import trans from "../../utils";

export default function AntDatePicker({
	item,
	activeInput,
	preview,
	disable,
	addData,
	setSubmitData,
	submitData,
	// Opt-in only: forms that print a time alongside the date (Near Miss) pass this, every
	// other caller keeps the plain date picker it has always rendered.
	showTime,
}) {
	const [value, setValue] = useState(""); // null instead of ""
	const currentValue = addData
		? submitData?.find((i) => i.key === item.key)?.value ?? ""
		: item?.value ?? value ?? "";
	const validate = addData
		? addData?.touched?.fields?.[item?.key]?.value &&
		  item?.required?.value &&
		  currentValue === ""
		: item?.required?.value && value === "";
	const styleValidate = addData
		? addData?.touched?.fields?.[item?.key]?.value &&
		  item?.required?.value &&
		  currentValue === ""
		: preview !== true && value === "" && item?.required?.value;
	return (
		<div style={item?.css}>
			<label
				htmlFor={item?.key || "date-picker"}
				className="form-label d-flex align-items-center"
				style={{
					color: item?.css?.color,
					fontFamily: item?.css?.fontFamily,
					fontSize: item?.css?.fontSize,
					fontWeight: item?.css?.fontWeight,
				}}
			>
				{item?.title}
				{item?.required?.value && !value && (
					<div className="text-danger ms-2">*</div>
				)}
			</label>

			<DatePicker
				key={activeInput}
				id={item?.key}
				placeholder={item?.placeholder}
				style={{
					width: "100%",
				}}
				showTime={showTime ? { format: "HH:mm" } : false}
				format={showTime ? "YYYY-MM-DD HH:mm" : undefined}
				status={styleValidate ? "error" : ""}
				// 👇 AntD DatePicker expects a dayjs object, not string
				// ensure we pass a dayjs object or null to avoid "Invalid Date"
				value={
					// if it's already a dayjs object, use it; if it's a non-empty string convert; otherwise null
					dayjs.isDayjs(currentValue)
						? currentValue
						: currentValue
						? dayjs(currentValue)
						: null
				}
				onChange={(date /* dayjs object */, dateString) => {
					setValue(date); // store the dayjs object
					if (addData) {
						setSubmitData((prev) => {
							// Remove existing item with same key if you want to replace it
							const filtered = prev?.filter((i) => i.key !== item.key) || [];
							return [
								...filtered,
								{
									key: item.key,
									name: item.name,
									title: item.title,
									value: dateString,
								},
							];
						});

						addData.setFieldTouched(`fields[${item.key}].value`, true);
					}
				}}
				onBlur={() => {
					if (addData) {
						addData.setFieldTouched(`fields[${item?.key}].value`, true);
					}
				}}
				getPopupContainer={(triggerNode) => triggerNode.parentNode}
				placement="bottomLeft"
				allowClear={disable}
				inputReadOnly={!disable} // prevents typing
			/>

			{validate && (
				<div className="text-danger mt-1">
					{trans(item?.required?.validationMessage)}
				</div>
			)}
		</div>
	);
}
